<template>
  <div v-if="disabled" class="ql-container ql-snow">
    <div class="ql-editor" v-html="value" ></div>
  </div>
  <div class="rich-text" v-else>
    <div ref="richDOM"></div>
  </div>
</template>
<script>
import Quill from 'quill'
import 'quill/dist/quill.snow.css'
export default {
  name: 'RichText',
  props: ['value', 'disabled', 'placeholder'],
  data() {
    return {
      richtext: null,
    }
  },
  mounted() {
    const quillOptions = {
      theme: 'snow',
      placeholder: this.placeholder,
      modules: {
        toolbar: {
          container: [
            'bold',
            'italic',
            'underline',
            'strike',
            { list: 'ordered' },
            { list: 'bullet' },
            { color: [] },
            { background: [] },
            { size: [false, 'small', 'large', 'huge'] },
            'clean',
            'image',
          ],
          handlers: {
            image: (value) => {
              if (value) {
                let inputDOM = document.querySelector('input.ql-image')
                if (!inputDOM) {
                  inputDOM = document.createElement('input')
                  inputDOM.type = 'file'
                  inputDOM.accept = 'image/png, image/gif, image/jpeg, image/webp'
                  inputDOM.classList.add('ql-image')
                  inputDOM.style.display = 'none'
                  inputDOM.addEventListener('change', (e) => {
                    const formDate = new FormData()
                    formDate.append(
                      'folder',
                      `/goods/info/${this.$dayjs().format('YYYYMMDD')}`
                    )
                    formDate.append('file', e.target.files[0])
                    this.$axios
                      .post('/funs/upload/image', formDate)
                      .then((data) => {
                        const range =  this.richtext.getSelection()
                        this.richtext.insertEmbed(
                          range.index,
                          'image',
                          this.$envConst.IMAGE_ORIGIN + data
                        )
                        this.richtext.setSelection(range.index +1)
                        // this.richtext.format(
                        //   'image',
                        //   this.$envConst.IMAGE_ORIGIN + data
                        // )
                        inputDOM.value = ''
                      })
                  })
                  document.querySelector('.ql-toolbar').append(inputDOM)
                  console.log(document.querySelector('.ql-toolbar'))
                }
                inputDOM.click()
              }
            },
          },
        },
      },
    }
    this.richtext = new Quill(this.$refs.richDOM, quillOptions)
    this.richtext.root.addEventListener(
      'paste',
      (evt) => {
        if (
          evt.clipboardData &&
          evt.clipboardData.files &&
          evt.clipboardData.files.length
        ) {
          evt.preventDefault()
          //上传服务器并拿到返回的图片地址，插入到富文本中
          uploadClipBoardFile(evt.clipboardData)
        }
      },
      true //注意
    )
    var that=this
    function uploadClipBoardFile(data) {
      [].forEach.call(data.files, (file) => {
        const formDate = new FormData()
        formDate.append(
          'folder',
          `/goods/info/${that.$dayjs().format('YYYYMMDD')}`
        )
        formDate.append('file', file)
        that.$axios.post('/funs/upload/image', formDate).then((data) => {
          const range = that.richtext.getSelection()
          that.richtext.insertEmbed(
            range.index,
            'image',
            that.$envConst.IMAGE_ORIGIN + data
          )
          that.richtext.setSelection(range.index + 1)
        })
      })
    }

    this.richtext.on(
      'editor-change',
      this.$_.debounce(() => {
        this.$emit('input', this.richtext.root.innerHTML)
      }, 800)
    )
    if (this.value) {
      this.richtext.root.innerHTML = this.value
    }
  },
  methods: {
    // htmlDecode(str) {
    //   var t = document.createElement('div')
    //   t.innerHTML = str
    //   return t.innerText || t.textContent
    // },
  },
}
</script>
<style lang="stylus" scoped>
.rich-text
  &.disabled::before
    content ''
    position absolute
    top 0
    left 0
    width 100%
    height 100%
    background rgba(#ddd, 0.5)
    z-index 5
    cursor not-allowed
</style>
